import React, { useState } from "react";
// Eliminamos imports de botones y useEffect manual para ESC, ya que DrawerFilter lo maneja
import CertificadoAutocomplete from "../../../components/autocomplete/CertificadoAutocomplete";
import ClienteAutocomplete from "../../../components/autocomplete/ClienteAutocomplete";
import DrawerFilter from "../../../components/listing/DrawerFilter";

export default function FiltroCertificadoCliente({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  // --- ESTADOS DE FILTROS ---
  const [certificadoObj, setCertificadoObj] = useState(null);
  const [clienteObj, setClienteObj] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // --- SUBMIT ---
  const handleApply = () => {
    setIsLoading(true);
    
    onSubmit({
      // Extraemos solo el ID para el filtrado en el backend
      certificadoId: certificadoObj?.id || "",
      clienteId: clienteObj?.id || "",
    });

    setIsLoading(false);
    onClose();
  };

  return (
    <DrawerFilter
      title="Filtros de Certificados - Clientes"
      onClose={onClose}
      onApply={handleApply}
      isLoading={isLoading}
    >
      {/* TEXTO DE AYUDA (Mantenido del original) */}
      <div className="text-sm text-gray-500 italic">
        Seleccione los criterios para filtrar la relación:
      </div>

      {/* 1. Impuesto al Valor Selectivo (Certificados) */}
      <div>
        <label className="form-label-fil">Impuesto al Valor Selectivo (Certificados):</label>
        <div className="mt-1 w-full">
          <CertificadoAutocomplete
            value={certificadoObj}
            onChange={(obj) => setCertificadoObj(obj)}
            placeholder="Buscar por Nro de Certificado..."
          />
        </div>
      </div>

      {/* 2. Cliente */}
      <div>
        <label className="form-label-fil">Cliente:</label>
        <div className="mt-1 w-full">
          <ClienteAutocomplete
            value={clienteObj}
            onChange={(obj) => setClienteObj(obj)}
            placeholder="Buscar por nombre, código o documento..."
          />
        </div>
      </div>

    </DrawerFilter>
  );
}